import { AxiosResponse } from "axios";
import { useQuery } from "react-query";

import { MainUrl } from "core/data/main-url";
import { IAxiosResult } from "../../models/axios-result.model";
import methods from "../interceptors/http.interceptor";

const url = `${MainUrl}/api/store`;

const GetAllStores = async (
  productId: number,
): Promise<AxiosResponse<IAxiosResult>> => {
  return await methods.get(`${url}/Product/GetAllStores/${productId}`);
};
//-----------------------------------------------------------------------------------------------------------

export const useGetAllStores = (id: number) =>
  useQuery(["GetAllStores", id], () => GetAllStores(id), {
    enabled: !!id,
  });
